export enum AuthorizationGroups {
  Access = 'ProductSelector.Access',
  FittingsAdmin = 'ProductSelector.FittingsAdmin',
  ClosuresAdmin = 'ProductSelector.ClosuresAdmin',
  NoAccess = 'ProductSelector.NoAccess',
  ITAdmins = 'ITAdmins',
  SealingElementsAdmin = 'ProductSelector.SealingElementAdmin'
}
